module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "person-add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.languages.xiugaimima))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formCustom,
      "rules": _vm.ruleCustom,
      "label-width": 80
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.languages.yuanmima,
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formCustom.password),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "password", $$v)
      },
      expression: "formCustom.password"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.languages.xinmima,
      "prop": "newPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formCustom.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "newPassword", $$v)
      },
      expression: "formCustom.newPassword"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.languages.querenmima,
      "prop": "passwordCheck"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "number": ""
    },
    model: {
      value: (_vm.formCustom.passwordCheck),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "passwordCheck", $$v)
      },
      expression: "formCustom.passwordCheck"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formCustom')
      }
    }
  }, [_vm._v(_vm._s(_vm.languages.queding))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a441558a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePwd.vue
// module id = 937
// module chunks = 1